<div class="legal-view">
    <div class="legal-section">
        <h3 class="legal-label">Legal</h3>
        <ccdl-divider size="md"></ccdl-divider>
    </div>

    <div class="legal-title-section">
        <h1 class="legal-title">Privacy Policy</h1>
        <ccdl-divider size="sm"></ccdl-divider>
    </div>

    <div class="legal-content">
        <div class="last-updated"><em>Last Updated:</em> April 13, 2026</div>

        <div class="content-block">
            <h3 class="content-header">Introduction</h3>
            <p class="content-paragraph">Welcome to Capvizon. We respect your
                privacy and are committed
                to protecting your personal data. This Privacy Policy outlines
                how we collect, use,
                store, and protect information for users in the USA, UK, Canada,
                India, and Australia.
            </p>
            <p class="content-paragraph">By using Capvizon, you acknowledge that
                you have read and
                understood this Privacy Policy and agree to the collection and
                use of your information in
                accordance with it. If you do not agree to this policy, please
                do not use our services.
            </p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Data We Collect</h3>
            <p class="content-paragraph">We collect personal information
                necessary to provide our
                expense tracking services:</p>
            <p class="content-paragraph"><strong class="sub-header">Identity
                    Data:</strong> Name,
                Physical Address.</p>
            <p class="content-paragraph"><strong class="sub-header">Contact
                    Data:</strong> Email
                Address, Phone Number.</p>
            <p class="content-paragraph"><strong class="sub-header">Financial
                    Input:</strong> Manual
                entries of expenses, group balances, and categories.</p>
            <p class="content-paragraph"><strong class="sub-header">Technical
                    Data:</strong> Internet
                protocol (IP) address, browser type and version, time zone
                setting and location,
                operating system and platform, and other technology on the
                device you use to access our
                Site.</p>
            <p class="content-paragraph"><strong class="sub-header">Usage
                    Data:</strong> Information
                about how you use our website and services, including pages
                visited, time spent on pages,
                and navigation paths.</p>
            <p class="content-paragraph"><strong
                    class="content-strong">Note:</strong> We do not
                process or store bank account or credit card numbers. Capvizon
                is an information storage
                and calculation tool only and does not facilitate any payment
                transactions.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">How We Use Your Data</h3>
            <p class="content-paragraph">We use your personal data for the
                following purposes:</p>
            <p class="content-paragraph"><strong class="sub-header">Service
                    Delivery:</strong> To
                provide and maintain our expense tracking platform, including
                expense logging,
                calculation, and group management features.</p>
            <p class="content-paragraph"><strong class="sub-header">Account
                    Management:</strong> To
                manage your registration, authenticate your identity, and
                maintain your account.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Communication:</strong> To contact
                you regarding updates, security alerts, and administrative
                messages related to your
                account.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Improvement:</strong> To analyze
                usage patterns and improve our Site, services, and user
                experience.</p>
            <p class="content-paragraph"><strong class="sub-header">Legal
                    Compliance:</strong> To
                comply with legal obligations and respond to lawful requests
                from public authorities.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Age Eligibility</h3>
            <p class="content-paragraph">Our services are not intended for
                children under the age of
                13. By using this Site, you confirm that you are at least 13
                years old. We do not
                knowingly collect data from children under this age. If we
                become aware that we have
                collected personal data from a child under 13, we will take
                steps to delete that
                information promptly.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Data Storage &amp; International
                Transfers</h3>
            <p class="content-paragraph">Your data is stored on secure servers
                in India and the United
                States. By using our services, you acknowledge that your
                information may be transferred
                to and processed in these countries, which may have different
                data protection laws than
                your country of residence.</p>
            <p class="content-paragraph">We implement appropriate technical and
                organizational measures
                to ensure a level of security appropriate to the risk, including
                encryption of data in
                transit and at rest, regular security assessments, and access
                controls.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Cookies &amp; Tracking Technologies</h3>
            <p class="content-paragraph">We use cookies and similar tracking
                technologies to track
                activity on our Site and hold certain information. Cookies are
                files with a small amount
                of data which may include an anonymous unique identifier.</p>
            <p class="content-paragraph"><strong class="sub-header">Essential
                    Cookies:</strong>
                Required for the operation of our Site. They enable core
                functionality such as security,
                account authentication, and session management.</p>
            <p class="content-paragraph"><strong class="sub-header">Analytics
                    Cookies:</strong> Help us
                understand how visitors interact with our Site by collecting and
                reporting information
                anonymously.</p>
            <p class="content-paragraph">You can instruct your browser to refuse
                all cookies or to
                indicate when a cookie is being sent. However, if you do not
                accept cookies, you may not
                be able to use some portions of our Site.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Data Retention &amp; Deletion</h3>
            <p class="content-paragraph">We retain your information only as long
                as your account is
                active or as needed to provide you our services. You may delete
                your account and all
                associated data at any time through your Profile Page.</p>
            <p class="content-paragraph">Upon account deletion, we will remove
                your personal data from
                our active databases within 30 days. Some information may be
                retained in backup archives
                for a limited period as required by law or for legitimate
                business purposes.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Your Rights</h3>
            <p class="content-paragraph">Depending on your location, you may
                have the following rights
                regarding your personal data:</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Access:</strong> The right to
                request copies of your personal data held by us.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Rectification:</strong> The right
                to request correction of any inaccurate personal data we hold
                about you.</p>
            <p class="content-paragraph"><strong
                    class="sub-header">Erasure:</strong> The right to
                request that we delete your personal data, subject to certain
                conditions.</p>
            <p class="content-paragraph"><strong class="sub-header">Data
                    Portability:</strong> The
                right to request that we transfer your data to another
                organization or directly to you.
            </p>
            <p class="content-paragraph"><strong
                    class="sub-header">Objection:</strong> The right to
                object to our processing of your personal data in certain
                circumstances.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Third-Party Links</h3>
            <p class="content-paragraph">Our Site may contain links to other
                websites that are not
                operated by us. If you click on a third-party link, you will be
                directed to that third
                party's site. We strongly advise you to review the Privacy
                Policy of every site you
                visit. We have no control over and assume no responsibility for
                the content, privacy
                policies, or practices of any third-party sites or services.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Copyright and Infringement (DMCA/IP)</h3>
            <p class="content-paragraph">If you believe that any content on
                Capvizon infringes upon
                your intellectual property rights, please notify us at
                <ccdl-link
                    linkText="Privacy and Terms Team." linkType="default"
                    size="xs"
                    [underlineOnHover]="true" [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link>
            </p>
            <p class="content-paragraph"><strong class="sub-header">Response
                    Period:</strong> We will
                review and respond to valid infringement claims. Formal legal
                review regarding such
                claims shall only be initiated if no resolution or response is
                provided by us within
                <strong class="content-strong">90 days</strong> of your initial
                email notice.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Changes to This Privacy Policy</h3>
            <p class="content-paragraph">We may update our Privacy Policy from
                time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page and updating the
                "Last Updated" date at the top. You are advised to review this
                Privacy Policy
                periodically for any changes. Changes to this Privacy Policy are
                effective when they are
                posted on this page.</p>
        </div>

        <div class="content-block">
            <h3 class="content-header">Contact Information</h3>
            <p class="content-paragraph">For any privacy inquiries or to
                exercise your data rights
                (such as access, rectification, or erasure), please contact:
                <ccdl-link linkText="Privacy and Terms Team." linkType="default"
                    size="xs"
                    [underlineOnHover]="true" [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link>
            </p>
        </div>

        <div class="content-footer">
            <h3 class="content-header">Feedback and Site Updates</h3>
            <p class="footer-text">Any comments or suggestions you share on this
                site are considered non-confidential.</p>
            <p class="footer-text">Capvizon reserves the right to use this
                feedback freely and without any limitations. Additionally, the
                content on this website may be updated or modified at any time
                without prior warning.</p>
        </div>
    </div>
</div>
